import React, { useEffect, useState, useRef } from "react";
import { Bar } from "react-chartjs-2";
import { getGraphData } from "./../../utils/graphManager";
import { PDFGenerator } from "../common/PdfGenerator";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { YEARS } from "../../utils/constantData";
import { getMonthlyUsers } from ".";
import { ExportExcel } from "../common/ExcelGenerator";
import { ExportCSV } from "../common/CsvGenerator";
import { barChartOptions } from "../../utils/chartTheme";
import { buildDateRangeParams } from "../common/DateRangeFilter";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export default function UserSignupComponent({ dateFilter }) {
  function getData(data, label, labels) {
    return {
      labels,
      data: data,
      datasets: [
        {
          label: label + " SignUp(s)",
          data: data,
          backgroundColor: "rgba(63, 122, 42, 0.72)",
          borderRadius: 10,
          maxBarThickness: 34,
        },
      ],
    };
  }

  const [data, setData] = useState({});
  const [dataPdf, setDataPdf] = useState([]);
  const chartRef = useRef(null);

  function getCount(data) {
    return Object.keys(data).map((key) => {
      const count = data[key]?.count || 0;
      const dataP = data[key].users;
      setDataPdf((prevData) => {
        const isDuplicate = prevData.some((item) => item.key === key);
        if (!isDuplicate) {
          return [...prevData, { data: dataP, key: key }];
        }
        return prevData;
      });
      return [0, count];
    });
  }

  useEffect(() => {
    setDataPdf([])
    async function fetchData() {
      try {
        const response = await getMonthlyUsers(buildDateRangeParams(dateFilter));
        const responseData = response.data;
        setData(getCount(responseData?.data?.monthlyUsers || {}));
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();
  }, [dateFilter]);

  return (
    <div className="chart-panel">
      <div className="chart-panel__header">
        <div>
          <span className="chart-panel__eyebrow">Acquisition</span>
          <h2 className="chart-panel__title">New user signups</h2>
          <p className="chart-panel__description">
            Monitor how registrations trend over the selected date range.
          </p>
        </div>
      </div>
      <div className="chart-canvas">
        <Bar
          ref={(ref) => {
            chartRef.current = ref;
          }}
          options={barChartOptions}
          data={getData(getGraphData(data), "Monthly", YEARS)}
        />
      </div>
      <div className="chart-actions">
        <ExportExcel fileName="Monthly Signup" excelData={dataPdf} />
        <ExportCSV fileName="Monthly Signup" csvData={dataPdf} />
        <PDFGenerator data={dataPdf} name="Monthly Signup" />
      </div>
    </div>
  );
}
